import { cdnURL } from './utils';
import { isDev, isStage } from './constants';

const timestamp = new Date().getTime();
let url = `${cdnURL}live.json`;

export default () => {

  if (isDev) {
    return Promise.resolve(require('./live'));
  }

  if (isStage) {
    url = `${cdnURL}sta_live.json`;
  }

  const urlWithTimestamp = `${url}?t=${timestamp}`;

  return fetch(urlWithTimestamp)
    .then(response => response.json())
    .catch(err => console.error(err));
};



// WEBPACK FOOTER //
// ./src/lib/loadLive.js